import { render, staticRenderFns } from "./OfferSidebar.vue?vue&type=template&id=53d07416&scoped=true&lang=pug"
import script from "./OfferSidebar.vue?vue&type=script&lang=js"
export * from "./OfferSidebar.vue?vue&type=script&lang=js"
import style0 from "./OfferSidebar.vue?vue&type=style&index=0&id=53d07416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d07416",
  null
  
)

export default component.exports